import { App } from 'vue';
import AutoCounter from './AutoCounter.vue';
import AnimateValue from './AnimateValue.vue';

export default function config(app: App) {
    app.component('AutoCounter', AutoCounter);
    app.component('AnimateValue', AnimateValue);
}